import PhotoSizeDimensions from '@alltrails/types/PhotoSizeDimensions';
import getPhotoSizeServerFromDimensions from './getPhotoSizeServerFromDimensions';
import { X_AT_KEY } from './api';

type Args = {
  baseUrl?: string;
  cardType: 'maps' | 'trails';
  id: string | number;
  index: number;
  size: PhotoSizeDimensions;
};

const getCardPhotoUrl = ({ baseUrl, cardType, id, index, size }: Args) => {
  const params = new URLSearchParams();
  params.set('key', X_AT_KEY);
  params.set('size', getPhotoSizeServerFromDimensions(size));

  return `${baseUrl || ''}/api/alltrails/v2/${cardType}/${id}/photos/${index}?${params.toString()}`;
};

export default getCardPhotoUrl;
